import { atomWithStorage } from 'jotai/utils'
import { useAtomValue, useSetAtom } from 'jotai'
import {
  SHOP_SESSION_FLAGS_SESSION_STORAGE,
  initialShopSessionFlags,
  type ShopSessionFlagKey,
} from '@/features/shop/state/ShopSessionFlags/constants'

export const shopSessionFlagsAtom = atomWithStorage<Record<string, boolean>>(
  SHOP_SESSION_FLAGS_SESSION_STORAGE,
  initialShopSessionFlags,
  {
    getItem: (key) => {
      try {
        return JSON.parse(window.sessionStorage.getItem(key) ?? '')
      } catch {
        return initialShopSessionFlags
      }
    },
    setItem: (key, value) => window.sessionStorage.setItem(key, JSON.stringify(value)),
    removeItem: (key) => window.sessionStorage.removeItem(key),
  },
)
shopSessionFlagsAtom.debugLabel = 'shopSessionFlagsAtom'

export const useShopSessionFlagValue = (key: ShopSessionFlagKey) =>
  Boolean(useAtomValue(shopSessionFlagsAtom)[key])

export const useSetShopSessionFlag = () => {
  const setShopSessionFlags = useSetAtom(shopSessionFlagsAtom)
  return (key: ShopSessionFlagKey, value: boolean) => {
    setShopSessionFlags((prev) => ({ ...prev, [key]: value }))
  }
}
